export const BASE_TABS_CLASS_NAMES = {
  tab: 'propelio-tab',
}
